import EmbedAnalytics from "./EmbedAnalytics";

export default EmbedAnalytics;
